module.exports = __webpack_public_path__ + "img/jshc.34ebbd02.png";